import { render, staticRenderFns } from "./featureConfiguration.vue?vue&type=template&id=05357bd0&scoped=true&"
import script from "./featureConfiguration.vue?vue&type=script&lang=js&"
export * from "./featureConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./featureConfiguration.vue?vue&type=style&index=0&id=05357bd0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05357bd0",
  null
  
)

export default component.exports